<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>订单维护</el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card>
        <el-row :gutter="0">
          <el-col :span="10">
            <el-input
              placeholder="请输入查询内容"
              v-model="queryInfo.query"
              class="input-with-select"
              clearable
              style="width:300px "
              @clear="getorderList"
              @change="getorderList"
            >
              <el-button slot="append" icon="el-icon-search" @click="getorderList"></el-button>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="get_order_add" v-if="false">添加订单</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="0" class="el_row_two">
          <el-col :span="24">
            <el-table :data="orderList" style="width: 100%" border stripe>
              <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
              <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
              <el-table-column prop="order_bianhao" label="编号" width="200"></el-table-column>
              <el-table-column prop="order_money" label="金额"></el-table-column>
              <el-table-column prop="guest_mob" label="客户手机"></el-table-column>
              <el-table-column prop="add_time" label="订单时间"></el-table-column>
              <el-table-column prop="yuangong_bianhao" label="操作员工"></el-table-column>
              <el-table-column prop="yuangong_name" label="员工姓名"></el-table-column>
              <el-table-column prop="add_time" label="订单时间"></el-table-column>
              <el-table-column prop="add_time" label="订单时间"></el-table-column>
              <el-table-column   label="车型" width="400">
                <template v-slot="scope">  {{ scope.row.chexing01 }} : {{ scope.row.chexing02 }} : {{ scope.row.chexing03 }} : {{ scope.row.chexing04 }}</template>
              </el-table-column>
              <el-table-column prop="pay_flag" label="支付状态" width="130">
                <template v-slot="scope"> <span> {{scope.row.pay_flag === 1 ? '已支付':'未支付' }}</span></template>
              </el-table-column>
              
              <el-table-column label="操作" v-if="false">
                <template v-slot="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="修改"
                    placement="top"
                    :enterable="false"
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      @click="showEditDialog(scope.row.uid)"
                      circle
                      size="mini"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    :enterable="false"
                  >
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      @click="deleteForm(scope.row.uid)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="订单回访"
                    placement="top"
                    :enterable="false"
                    style="display: none;"
                  >
                    <el-button
                      type="success"
                      icon="el-icon-orange"
                      @click="showHuifangDialog(scope.row.uid)"
                      circle
                      size="mini"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.pageNum"
          :page-sizes="[10,50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
          <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
        </el-pagination>
        <!-- 订单回访窗口 -->
  
        <el-dialog
          title="订单回访"
          :visible.sync="huifangDialogVisible"
          width="50%"
          @close="huifangDoalogClosed"
        >
          <el-form
            ref="huifangFormRef"
            :model="huifangForm"
            :rules="huifangFormRefRules"
            label-width="100px"
          >
            <el-card class="card_two" style="height:140px; margin-top:0px; margin-bottom:20px; ">
              <el-row :gutter="20">
                <el-col :span="10">
                  <div class="grid-content bg-purple">
                    <el-form-item label="订单编号" prop="order_bianhao">{{editForm.order_bianhao}}</el-form-item>
                    <el-form-item label="订单姓名" prop="order_name">{{editForm.order_name}}</el-form-item>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple">
                    <el-form-item label="联系手机号" prop="order_mob">{{editForm.order_mob}}</el-form-item>
                    <el-form-item label="联系地址" prop="order_addr">{{editForm.order_addr}}</el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-card>
            <el-form-item label="回访标题" prop="huifang_title">
              <el-input v-model="huifangForm.huifang_title" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="回访内容" prop="hufiang_memo">
              <el-input
                v-model="huifangForm.hufiang_memo"
                :autosize="{ minRows: 2, maxRows: 8}"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否需要跟进" prop="huifang_genjin">
              <el-switch
                v-model="huifangForm.huifang_switch"
                @change="get_switch_value(huifangForm.huifang_switch)"
              ></el-switch>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="huifangDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addHuifang" :disabled="huifang_isDisable">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 添加订单部分 -->
        <el-dialog title="添加订单" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
          <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
            <el-form-item label="订单编号" prop="order_bianhao">
              <el-input v-model="addForm.order_bianhao" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="订单姓名" prop="order_name">
              <el-input v-model="addForm.order_name"></el-input>
            </el-form-item>
            <el-form-item label="联系手机号" prop="order_mob">
              <el-input v-model="addForm.order_mob" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="order_addr">
              <el-input v-model="addForm.order_addr" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="order_sfz_bianhao">
              <el-input v-model="addForm.order_sfz_bianhao" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="订单等级" prop="order_level">
              <el-select v-model="addForm.order_level" placeholder="请选择订单等级">
                <el-option
                  v-for="item in order_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单心理价位" prop="order_addr">
              <el-input v-model="addForm.order_price_want" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="订单意向" prop="order_addr">
              <el-input v-model="addForm.order_yixiang" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="订单备注" prop="order_addr">
              <el-input v-model="addForm.order_memo" max="11" min="10"></el-input>
            </el-form-item>
  
            <el-form-item label="订单来源" prop="order_laiyuan">
              <el-select v-model="addForm.order_laiyuan" placeholder="请选择订单来源">
                <el-option
                  v-for="item in orderLy_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addorder" :disabled="add_isDisable">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 修改订单信息 -->
        <el-dialog
          title="修改订单信息"
          :visible.sync="editDialogVisible"
          width="50%"
          @close="editDoalogClosed"
        >
          <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
            <el-form-item label="订单编号" prop="order_bianhao">
              <el-input v-model="editForm.order_bianhao" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="订单姓名" prop="order_name">
              <el-input v-model="editForm.order_name"></el-input>
            </el-form-item>
            <el-form-item label="联系手机号" prop="order_mob">
              <el-input v-model="editForm.order_mob" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="order_addr">
              <el-input v-model="editForm.order_addr" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="order_sfz_bianhao">
              <el-input v-model="editForm.order_sfz_bianhao" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="订单等级" prop="order_level">
              <el-select v-model="editForm.order_level" placeholder="请选择订单等级">
                <el-option
                  v-for="item in order_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单心理价位" prop="order_addr">
              <el-input v-model="editForm.order_price_want" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="订单意向" prop="order_addr">
              <el-input v-model="editForm.order_yixiang" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="订单备注" prop="order_addr">
              <el-input v-model="editForm.order_memo" max="11" min="10"></el-input>
            </el-form-item>
  
            <el-form-item label="订单来源" prop="order_laiyuan">
              <el-select v-model="editForm.order_laiyuan" placeholder="请选择订单来源">
                <el-option
                  v-for="item in orderLy_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateorder">确 定</el-button>
          </span>
        </el-dialog>
      </el-card>
    </div>
  </template>
  <script>
   import { checkMobileTest, checkSfzId } from './config/validator';
  export default {
    data() {
      return {
        orderLy_options: [
          {
            value: 1,
            label: '订单介绍'
          },
          {
            value: 2,
            label: '回访订单'
          },
          {
            value: 3,
            label: '上门订单'
          }
        ],
        order_options: [
          {
            value: 1,
            label: '初级订单'
          },
          {
            value: 2,
            label: '中级订单'
          },
          {
            value: 3,
            label: '高级订单'
          }
        ],
        // 获取用户列表参数
        queryInfo: {
          C_type: 'get_list',
          C_table_name: 'order_list',
          query: '',
          pageNum: 1,
          pageSize: 10,
          qiye_uid: window.sessionStorage.getItem('qiye_uid')
        },
        huifang_isDisable: false,
        add_isDisable: false,
        orderList: [],
        //  recordCount: 0,
        total: 0,
        addDialogVisible: false,
        editDialogVisible: false,
        huifangDialogVisible: false,
  
        // 用于设置回访页面滑块值
        //  添加表单数据项
        huifangForm: {
          C_type: 'huifang_add',
          huifang_order_uid: 0,
          huifang_title: '',
          hufiang_memo: '',
          huifang_genjin: 1,
          huifang_yuangong_uid: 0,
          huifang_switch: true
        },
        addForm: {
          C_type: 'order_add',
          order_bianhao: '',
          order_name: '',
          order_mob: '11111111111',
          order_addr: '',
          order_sfz_bianhao: '111111111111111111',
          order_level: 1,
          order_price_want: 0,
          order_yixiang: '',
          order_memo: '',
          order_laiyuan: 1
        },
        // 用于修改数据绑定
        editForm: {},
        // 表单规则项
        addFormRules: {
          order_name: [
            { required: true, message: '请输入订单名称', trigger: 'blur' },
            { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
          ],
  
          order_mob: [
            {
              validator: checkMobileTest.bind(
                this.addForm && this.addForm.order_mob
              )
            }
          ],
          order_sfz_bianhao: [
            {
              validator: checkSfzId.bind(
                this.addForm && this.addForm.order_sfz_bianhao
              )
            }
          ]
        },
  
        huifangFormRefRules: {
          huifang_title: [
            { required: true, message: '请输入回访标题', trigger: 'blur' },
            { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
          ]
        }
      };
    },
    created() {
      this.getorderList();
    },
    methods: {
      get_switch_value(switchValue) {
        this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
        console.log(this.huifangForm.huifang_genjin);
      },
      async huiFangAdd() {
        const { data: res } = await this.$http.post('api', this.huifangForm);
        console.log(JSON.parse(res.data)[0].bianhao_s);
        this.huifangDialogVisible = true;
      },
      async get_order_add() {
        const { data: res } = await this.$http.get('get_api', {
          params: { C_type: 'get_bianhao', C_table_type: 3 }
        });
        console.log(JSON.parse(res.data)[0].bianhao_s);
        this.addForm.order_bianhao = JSON.parse(res.data)[0].bianhao_s;
        // this.total = JSON.parse(res.data)[0].total
        this.addDialogVisible = true;
      },
  
      async getorderList() {
        const { data: res } = await this.$http.get('get_api', {
          params: this.queryInfo
        });
        // console.log(JSON.parse(res.data))
        this.orderList = JSON.parse(res.data)[0].dataList;
  
        if (!this.orderList) return;
        this.orderList.forEach(function(item) {
          item.yong_flag = item.yong_flag === 1;
        });
  
        this.total = JSON.parse(res.data)[0].total;
  
        // console.log(this.total)
      },
      //  分页第一项下拉触发
  
      handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        this.getorderList();
      },
      // 选择页数触发
      handleCurrentChange(newPage) {
        this.queryInfo.pageNum = newPage;
        this.getorderList();
      },
  
      async addorder() {
        this.$refs.addFormRef.validate(async valid => {
          if (!valid) return 1;
           this.add_isDisable = true
           setTimeout(() => {
             this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
         }, 2000)
          const { data: res } = await this.$http.post('api', this.addForm);
          console.log(JSON.parse(res.data)[0].status);
          if (JSON.parse(res.data)[0].status === 201) {
              this.$message.error('手机号码重复')
              return
            } else if ((JSON.parse(res.data)[0].status !== 200) && (JSON.parse(res.data)[0].status !== 201)) {
            this.$message.error('添加失败')
            return
          }
          this.$message.success('添加成功');
          this.getorderList();
          this.addDialogVisible = false;
        });
      },
      async addHuifang() {
        this.$refs.huifangFormRef.validate(async valid => {
          if (!valid) return 1;
          this.huifang_isDisable = true
         setTimeout(() => {
             this.huifang_isDisable = false // 点击一次时隔两秒后才能再次点击
         }, 2000)
  
          const { data: res } = await this.$http.post('api', this.huifangForm);
          console.log(JSON.parse(res.data)[0].status);
          if (JSON.parse(res.data)[0].status !== 200) {
            this.$message.error('添加失败');
            return;
          }
          this.$message.success('添加成功');
          this.getorderList();
          this.huifangDialogVisible = false;
        });
      },
      showEditDialog(uid) {
         this.orderInfo(uid);
        this.editDialogVisible = true;
      },
      addDoalogClosed() {
        this.$refs.addFormRef.resetFields();
      },
      huifangDoalogClosed() {
        this.$refs.huifangFormRef.resetFields();
      },
      showHuifangDialog(uid) {
        this.huifangDialogVisible = true;
        this.orderInfo(uid);
      },
      editDoalogClosed() {
        this.$refs.editFormRef.resetFields();
      },
      async orderInfo(uid) {
        const { data: res } = await this.$http.get('get_api', {
          params: { C_table_name: 'order_info', uid: uid, C_type: 'get_info' }
        });
        // console.log(JSON.parse(res.data))
        console.log(res.data);
        if (JSON.parse(res.data)[0].status !== 200) {
          return this.$message.error('读取失败');
        }
  
        this.editForm = JSON.parse(res.data)[0].data[0];
        this.huifangForm.huifang_order_uid = JSON.parse(res.data)[0].data[0].uid;
      },
      async updateorder() {
        this.$refs.editFormRef.validate(async valid => {
          if (!valid) return this.$message.error('验证错误！');
          this.editForm.C_type = 'order_update';
          // 对象加入一个项C_type
          const { data: res } = await this.$http.post('api', {
            C_type: 'order_update',
            order_bianhao: this.editForm.order_bianhao.trim(),
            order_name: this.editForm.order_name,
            order_mob: this.editForm.order_mob,
            order_addr: this.editForm.order_addr,
            order_sfz_bianhao: this.editForm.order_sfz_bianhao,
            order_level: this.editForm.order_level,
            order_price_want: this.editForm.order_price_want,
            order_yixiang: this.editForm.order_yixiang,
            order_memo: this.editForm.order_memo,
            order_laiyuan: this.editForm.order_laiyuan,
            order_uid: this.editForm.uid
          });
  
          if (JSON.parse(res.data)[0].status !== 200) {
            this.$message.error('更新失败');
            return;
          }
          this.$message.success('更新成功');
          this.getorderList();
          this.editDialogVisible = false;
        });
      },
      // 删除一条记录
      async deleteForm(orderUid) {
        // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
        // 异步操作有2个，1个对话框等待，1个是网络请求
        const comfirmResult = await this.$confirm(
          '确定删除该条记录, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err);
        console.log(comfirmResult);
        if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
        const { data: res } = await this.$http.post('api', {
          C_type: 'record_delete',
          C_table_name: 'order_del',
          C_data1: orderUid
        });
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('删除失败');
          return;
        }
        this.$message.success('删除成功');
        this.getorderList();
      }
    }
  };
  </script>
  <style lang="less" scoped>
  .card_two {
    margin-top: 30px;
    box-shadow: none !important ;
    background-color: #f2f6fc;
  }
  .el_row_two {
    margin-top: 30px;
  }
  </style>
